/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { subscriptionPurchaseRequestRequestSchema } from "./subscriptionPurchaseRequestRequestSchema.ts";
import { subscriptionPurchaseResponseSchema } from "./subscriptionPurchaseResponseSchema.ts";
import { unauthorizedSchema } from "./unauthorizedSchema.ts";

export const userSubscriptionPurchaseCreateStatus201Schema = subscriptionPurchaseResponseSchema.describe("Ответ на инициацию покупки.");

export const userSubscriptionPurchaseCreateStatus400Schema = errorResponseSchema;

export const userSubscriptionPurchaseCreateStatus401Schema = unauthorizedSchema.describe("Сериализатор 401 ошибки - для документации.");

export const userSubscriptionPurchaseCreateStatus503Schema = errorResponseSchema;

export const userSubscriptionPurchaseCreateResponseSchema = z.union([
	userSubscriptionPurchaseCreateStatus201Schema,
	userSubscriptionPurchaseCreateStatus400Schema,
	userSubscriptionPurchaseCreateStatus401Schema,
	userSubscriptionPurchaseCreateStatus503Schema,
]);

export const userSubscriptionPurchaseCreateDataSchemaJson = subscriptionPurchaseRequestRequestSchema
	.optional()
	.describe("Запрос на инициацию покупки подписки.");

export const userSubscriptionPurchaseCreateDataSchemaXml = subscriptionPurchaseRequestRequestSchema
	.optional()
	.describe("Запрос на инициацию покупки подписки.");

export const userSubscriptionPurchaseCreateDataSchema = z.union([userSubscriptionPurchaseCreateDataSchemaJson, userSubscriptionPurchaseCreateDataSchemaXml]);
